export default __webpack_public_path__ + "static/media/smallBusiness.353ade80.jpeg";